import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

export const PaginationLoader = () => {
  return (
    <Placeholder
      type="rect"
      color="#E0E0E0"
      style={{
        width: '33%',
        height: '88px',
        left: '33%',
        margin: '0',
        borderRadius: '44px'
      }}
    />
  );
};